'use client';
import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';

interface Resource {
  num: string;
  title: string;
  description: string;
  href: string;
  image: string;
  imageAlt: string;
}

const resources: Resource[] = [
{
  num: '01',
  title: 'Investors',
  description: 'Financial reports, performance metrics, and strategic outlook.',
  href: '/annual-reports',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5d1e2df-1765918132625.png",
  imageAlt: 'UNOC upstream exploration investment data and financial performance petroleum sector Uganda'
},
{
  num: '02',
  title: 'Partners',
  description: 'Procurement opportunities, tenders, and supplier registration.',
  href: '/sustainability/national-content',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be70aabc-1766316826073.png",
  imageAlt: 'UNOC national content partners and local supplier development programme Uganda oil gas'
},
{
  num: '03',
  title: 'Policymakers',
  description: 'ESG framework, compliance, and sustainability initiatives.',
  href: '/sustainability',
  image: 'https://www.unoc.co.ug/wp-content/uploads/2021/01/sustainability.jpg',
  imageAlt: 'UNOC sustainability and ESG compliance framework for government policymakers Uganda energy'
},
{
  num: '04',
  title: 'Media',
  description: 'Press releases, announcements, and media gallery.',
  href: '/news',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1db21991d-1767165456018.png",
  imageAlt: 'UNOC media press release Baker Hughes MoU signing ceremony Uganda petroleum news'
},
{
  num: '05',
  title: 'Public',
  description: 'Learn about our mandate, leadership, and national impact.',
  href: '/about',
  image: 'https://www.unoc.co.ug/wp-content/uploads/2021/04/National-content-ug.jpg',
  imageAlt: 'Ugandan community members learning about UNOC national oil company mandate and impact'
}];


export default function TailoredResources() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        {/* Header */}
        <div
          className="mb-16 max-w-3xl"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'none' : 'translateY(20px)',
            transition: 'opacity 0.6s ease, transform 0.6s ease'
          }}>
          
          <div className="flex items-center gap-3 mb-5">
            <span className="font-mono text-xs text-[#CC0000] tracking-[0.2em]">[ 02 ]</span>
            <div className="h-[1px] w-12 bg-[#CC0000]" />
            <span className="text-[#CC0000] text-xs font-bold uppercase tracking-[0.2em]" style={{ fontFamily: 'Inter, sans-serif' }}>Information For You</span>
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0F0F0F] leading-[1.05] tracking-tight"
            style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.025em' }}>
            
            Tailored <span className="text-[#CC0000]">resources</span>
          </h2>
        </div>

        {/* Resources grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-0 border-t border-l border-gray-200">
          {resources.map((res, i) =>
          <Link
            key={i}
            href={res.href}
            className="group relative bg-white border-r border-b border-gray-200 p-8 hover:bg-[#0F0F0F] transition-colors duration-300 flex flex-col"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'none' : 'translateY(20px)',
              transition: `opacity 0.6s ease ${0.08 * (i + 1)}s, transform 0.6s ease ${0.08 * (i + 1)}s, background-color 0.3s ease`
            }}>
            
              <div className="flex items-start justify-between mb-6">
                <span className="font-mono text-xs text-gray-400 group-hover:text-[#CC0000] tracking-[0.2em] transition-colors">
                  {res.num}
                </span>
                <div className="w-8 h-8 bg-[#CC0000] flex items-center justify-center rounded-sm opacity-0 group-hover:opacity-100 transition-opacity">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M7 7h10v10" />
                    <path d="M7 17 17 7" />
                  </svg>
                </div>
              </div>

              {/* Image */}
              <div className="relative aspect-square overflow-hidden mb-6 rounded-sm">
                <img
                src={res.image}
                alt={res.imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              
                <div className="absolute inset-0 bg-[#0F0F0F]/0 group-hover:bg-[#0F0F0F]/30 transition-colors duration-300" />
              </div>

              <h3
              className="text-xl font-extrabold text-[#0F0F0F] group-hover:text-white mb-3 transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}>
              
                {res.title}
              </h3>
              <p className="text-sm text-gray-500 group-hover:text-gray-300 leading-relaxed transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>
                {res.description}
              </p>
            </Link>
          )}
        </div>
      </div>
    </section>);

}